import React, { useEffect, useState } from "react";
import { Drawer, InputLabel } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import {
  Box,
  Grid,
  Typography,
  Avatar,
  IconButton,
  Button,
  List,
  ListItem,
  ListItemText,
  MenuItem,
  Radio,
} from "@mui/material";
import { IoMdClose } from "react-icons/io";
import CustomInput from "../Common/CustomInput";
import CustomSelect from "../Common/CustomSelect";
import { format, parseISO } from "date-fns";
import { useMutation, useQuery } from "@apollo/client";
import { DEACTIVATE_TEAM, UPDATE_TEAM_ROLE } from "../../Utils/Mutation";
import { GET_ROLES } from "../../Utils/Queries";
import { useSnackbarHook } from "../../hooks/useSnackbarHook";
import Loader from "../Common/Loader";

const formatDate = (dateString) => {
  const date = parseISO(dateString);
  return format(date, "dd-MM-yyyy hh:mma");
};

const useStyles = makeStyles((theme) => ({
  drawer: {
    width: 540,
    flexShrink: 0,
    p: 4,
  },
  drawerPaper: {
    width: 540,
    p: 4,
  },
  toolbar: theme.mixins.toolbar,
}));
const EditTeam = ({ open, onClose, data, refetch }) => {
  const classes = useStyles();

  const [updateRole, { loading: updateLoading }] =
    useMutation(UPDATE_TEAM_ROLE);
  const [deactivateTeam, { loading: deactivateLoading }] =
    useMutation(DEACTIVATE_TEAM);

  console.log(data, "DATUM");

  const { data: roles, loading } = useQuery(GET_ROLES);
  const [roleId, setRoleId] = useState("");

  const { handleClick } = useSnackbarHook();
  const [isEdit, setIsEdit] = useState(false);

  useEffect(() => {
    if (data) {
      setRoleId(data?.role?._id);
    }
  }, [data]);

  const handleEditRole = async () => {
    await updateRole({
      variables: {
        role: roleId,
      },
    })
      .then((res) => {
        handleClick("Role Updated Successfully", "success");
        onClose();
        refetch();
      })
      .catch((err) => {
        handleClick(`${err.message}`, "error");
      });
  };

  const handleDeactivateTeam = async () => {
    await deactivateTeam({
      variables: {
        userId: data._id,
      },
    })
      .then((res) => {
        handleClick("Team Deactivated Successfully", "success");
        onClose();
        refetch();
      })
      .catch((err) => {
        handleClick(`${err.message}`, "error");
      });
  };

  return (
    <Drawer
      className={classes.drawer}
      anchor="right"
      open={open}
      onClose={onClose}
      classes={{ paper: classes.drawerPaper }}
    >
      {(loading || updateLoading || deactivateLoading) && <Loader />}
      <Box sx={{ px: 4, py: 5 }} className={classes.toolbar}>
        <Box
          sx={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
          }}
        >
          <Typography
            sx={{
              fontFamily: "Lato",
              color: "#0D0D0D",
              fontSize: "20px",
              fontWeight: 700,
            }}
          >
            User Details
          </Typography>
          <IconButton onClick={onClose}>
            <IoMdClose style={{ fontSize: "20px", color: "#000" }} />
          </IconButton>
        </Box>

        {!isEdit && (
          <Box sx={{ mt: 6 }}>
            <List sx={{ width: "100%" }}>
              <Box
                sx={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                  columnGap: 2,
                  borderBottom: "0.5px solid #d7d7d7",
                  py: 2,
                }}
              >
                <Typography sx={{ fontWeight: 500 }}>Status</Typography>
                <Typography
                  sx={{
                    fontWeight: 500,
                    color: data?.activityStatus === "ACTIVE" && "#3FB763",
                  }}
                >
                  {data?.activityStatus}
                </Typography>
              </Box>
              <Box
                sx={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                  columnGap: 2,
                  borderBottom: "0.5px solid #d7d7d7",
                  py: 2,
                  mt: 1,
                }}
              >
                <Typography sx={{ fontWeight: 500 }}>First Name</Typography>
                <Typography color={"success"} sx={{ fontWeight: 500 }}>
                  {data?.firstName}
                </Typography>
              </Box>
              <Box
                sx={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                  columnGap: 2,
                  borderBottom: "0.5px solid #d7d7d7",
                  py: 2,
                  mt: 1,
                }}
              >
                <Typography sx={{ fontWeight: 500 }}>Last Name</Typography>
                <Typography color={"success"} sx={{ fontWeight: 500 }}>
                  {data?.lastName}
                </Typography>
              </Box>
              <Box
                sx={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                  columnGap: 2,
                  borderBottom: "0.5px solid #d7d7d7",
                  py: 2,
                  mt: 1,
                }}
              >
                <Typography sx={{ fontWeight: 500 }}>Email Address</Typography>
                <Typography color={"success"} sx={{ fontWeight: 500 }}>
                  {data?.email}
                </Typography>
              </Box>
              <Box
                sx={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                  columnGap: 2,
                  borderBottom: "0.5px solid #d7d7d7",
                  py: 2,
                  mt: 1,
                }}
              >
                <Typography sx={{ fontWeight: 500 }}>Role</Typography>
                <Typography color={"success"} sx={{ fontWeight: 500 }}>
                  {data?.role?.title}
                </Typography>
              </Box>
              <Box
                sx={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                  columnGap: 2,
                  borderBottom: "0.5px solid #d7d7d7",
                  py: 2,
                  mt: 1,
                }}
              >
                <Typography sx={{ fontWeight: 500 }}>Last seen</Typography>
                <Typography color={"success"} sx={{ fontWeight: 500 }}>
                  {data && formatDate(data?.updatedAt)}
                </Typography>
              </Box>
            </List>

            <Box sx={{ mt: 5 }}>
              <Button
                variant="contained"
                fullWidth
                sx={{ py: 2, borderRadius: "50px" }}
                onClick={() => setIsEdit(true)}
              >
                Update Role
              </Button>
              <Button
                onClick={handleDeactivateTeam}
                fullWidth
                color="error"
                sx={{ mt: 3 }}
              >
                {" "}
                Deactivate User
              </Button>
            </Box>
          </Box>
        )}

        {isEdit && (
          <Box sx={{ mt: 6 }}>
            <List sx={{ width: "100%" }}>
              {roles?.getAdminRoles?.map((item, index) => (
                <MenuItem
                  onClick={() => {
                    setRoleId(item._id);
                  }}
                  key={index}
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    columnGap: 2,
                    backgroundColor:
                      roleId === item._id ? "#f0f0f0" : "transparent",
                  }}
                >
                  <Radio checked={roleId === item._id} />
                  <Typography>{item.title}</Typography>
                </MenuItem>
              ))}
            </List>

            <Box sx={{ mt: 5 }}>
              <Button
                onClick={handleEditRole}
                disabled={roleId === data?.role?._id}
                variant="contained"
                fullWidth
                sx={{ py: 2, borderRadius: "50px" }}
              >
                Save Changes
              </Button>
              <Button
                onClick={() => setIsEdit(false)}
                fullWidth
                sx={{ py: 2, borderRadius: "50px" }}
              >
                Back to Details
              </Button>
            </Box>
          </Box>
        )}
      </Box>
    </Drawer>
  );
};
export default EditTeam;
